import React, { useMemo } from 'react';

import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Grid } from '@mui/material';

import useConfig from 'UI/customHooks/useConfig';

const DisplayStarsExpertise = ({ actualLevel, suggestedLevel, amountIncrease = 0 }) => {
  const config = useConfig();
  const supportedLevels = useMemo(() => config.cms?.features?.skills?.expertiseLevels ?? [], [
    config,
  ]);
  const style = useMemo(() => {
    return {
      color: '#dd7c00',
    };
  });
  return (
    <>
      {supportedLevels.map((supportedLevel, index) => (
        <Grid key={`${actualLevel}-${suggestedLevel}-${index}`}>
          {index <= actualLevel + amountIncrease ? (
            <StarIcon data-test={`star-icon${index}`} style={style} />
          ) : (
            <StarBorderIcon data-test={`star-icon${index}`} style={style} />
          )}
        </Grid>
      ))}
    </>
  );
};

export default DisplayStarsExpertise;
